import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
export function Modules() {
  return <section className="w-full bg-shell px-5 py-16 sm:px-8 lg:py-24" data-id="element-88" data-mp="1vx28k69y9eoz">
      <div className="mx-auto max-w-5xl" data-id="element-89" data-mp="1vxu3rfzmxaeq">
        <SectionHeading overline="El contenido" size="lg" title={<>
              Todo lo que incluye la{' '}
              <span className="italic text-terracotta-500" data-id="element-91" data-mp="147z6mx5jcgfi">guía completa</span>
            </>} data-id="element-90" data-mp="20woo4md9370y" />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-92" data-mp="189awn3sbn3o8">
          {modules.map(module => <article key={module.title} className="flex h-full flex-col rounded-3xl border border-gold-200/60 bg-cream p-6" data-id="element-93" data-mp="1i5dzkbuzz6c8">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-sage-100" data-id="element-94" data-mp="2olhkgjxsbgw3">
                <CheckIcon className="h-4 w-4 text-sage-700" aria-hidden="true" data-id="element-95" data-mp="2tizqa1gi9fzv" />
              </span>
              <p className="mt-5 text-[11px] font-semibold uppercase tracking-overline text-gold-600" data-id="element-96" data-mp="1syuz6zcz55j">
                {module.title}
              </p>
              <h3 className="mt-2 font-serif text-[1.4rem] leading-tight text-sage-800" data-id="element-97" data-mp="3oyzk79twala3">
                {module.body}
              </h3>
            </article>)}
        </div>
      </div>
    </section>;
}